import html5 from "../../assets/technologies/html.svg";
import css3 from "../../assets/technologies/css.svg";
import javascript from "../../assets/technologies/javascript.svg";
import reactjs from "../../assets/technologies/react.svg";
import styledComponents from "../../assets/technologies/styled-components.svg";
import tailwindcss from "../../assets/technologies/tailwindcss.svg";
import bootstrap from "../../assets/technologies/bootstrap.svg";
import sass from "../../assets/technologies/sass.svg";
import npm from "../../assets/technologies/npm.svg";
import laravel from "../../assets/technologies/laravel.svg";
import git from "../../assets/technologies/git.svg";
import github from "../../assets/technologies/github.svg";
import figma from "../../assets/technologies/figma.svg";
import adobexd from "../../assets/technologies/adobexd.svg";
import vscode from "../../assets/technologies/visual-studio-code.svg";

export const iconsData = [
  {
    id: 1,
    icon: html5,
    name: "HTML5",
  },
  {
    id: 2,
    icon: css3,
    name: "CSS3",
  },
  {
    id: 3,
    icon: javascript,
    name: "JavaScript",
  },
  {
    id: 4,
    icon: reactjs,
    name: "React JS",
  },
  {
    id: 5,
    icon: styledComponents,
    name: "Styled Components",
  },

  {
    id: 6,
    icon: tailwindcss,
    name: "TailwindCSS",
  },
  {
    id: 7,
    icon: bootstrap,
    name: "Bootstrap",
  },
  {
    id: 8,
    icon: sass,
    name: "SASS",
  },
  {
    id: 9,
    icon: npm,
    name: "Node Package Manager",
  },
  {
    id: 10,
    icon: laravel,
    name: "PHP Laravel",
  },
  {
    id: 11,
    icon: git,
    name: "Git",
  },
  {
    id: 12,
    icon: github,
    name: "GitHub",
  },
  {
    id: 13,
    icon: figma,
    name: "Figma",
  },
  {
    id: 14,
    icon: adobexd,
    name: "Adobe XD",
  },
  {
    id: 15,
    icon: vscode,
    name: "Visual Studio Code",
  },
];
